export const typeConstants = {
  ALLOWED: 0,
  MANAGER: 2,
  RECRUITER: 3,
  PLATFORM_ADMIN: 5,
  DATE: "date",
  STATUS: "status",
  LINK: "link",
  MODAL: "modal",
  TOGGLE: "toggle",
  IMAGE: "image"
};
